import { ChapterLabel, Container, CTAButton, FadeUp, MaskedLine, scrollToHash } from "./ui";

const TIERS = [
  {
    title: "BUSINESS",
    text: "Recherche et sélection des meilleures options Business selon vos dates et votre flexibilité.",
  },
  {
    title: "FIRST",
    text: "Accès aux cabines First et aux itinéraires les plus pertinents, conditions négociées.",
  },
  {
    title: "MULTI-CITY",
    text: "Itinéraires complexes et voyages sur mesure, coordonnés de bout en bout.",
  },
];

const TravelDesk = () => (
  <section id="travel" className="bg-surface py-28 md:py-40" data-testid="travel-section">
    <Container>
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-24">
        <div>
          <ChapterLabel num="07" label="Travel Desk" />
          <h2 className="mt-10 font-serif font-medium leading-[0.95] text-ivory text-[clamp(38px,4.8vw,76px)]">
            <MaskedLine delay={0.1}>VOTRE VOYAGE,</MaskedLine>
            <MaskedLine delay={0.2} className="text-champagne">
              NOTRE RECHERCHE.
            </MaskedLine>
          </h2>
          <FadeUp delay={0.25} className="mt-8">
            <p className="max-w-[480px] font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:text-base">
              Business, First ou voyage sur mesure.
            </p>
            <p className="mt-4 max-w-[480px] font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:text-base">
              Nous recherchons les meilleures solutions disponibles selon vos dates, vos
              contraintes et votre niveau de flexibilité.
            </p>
          </FadeUp>
          <FadeUp delay={0.35} className="mt-10">
            <CTAButton onClick={() => scrollToHash("#demande")} testid="travel-cta">
              Demander une recherche
            </CTAButton>
          </FadeUp>
        </div>

        <div className="flex flex-col justify-center">
          {TIERS.map((t, i) => (
            <FadeUp key={t.title} delay={0.12 + i * 0.1}>
              <div
                className="group border-t border-line py-8 transition-colors duration-500 last:border-b hover:border-champagne/30"
                data-testid={`travel-tier-${t.title.toLowerCase().replace(/\s/g, "-")}`}
              >
                <div className="flex items-baseline justify-between gap-6">
                  <h3 className="font-display text-[13px] font-semibold tracking-[0.22em] text-ivory transition-colors duration-300 group-hover:text-champagne">
                    {t.title}
                  </h3>
                  <span className="font-serif text-lg italic text-champagne/50">0{i + 1}</span>
                </div>
                <p className="mt-3 max-w-[440px] font-sans text-sm font-light leading-[1.7] text-neutral-400">
                  {t.text}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default TravelDesk;
